import { useIntersectionObserver } from '@/shared/lib/hooks/useIntersectionObserver';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';

//Infinity loading handler

export const usePaginate = (
  cb: () => any,
  config?: { deps?: any[]; initialPage?: number; data?: any[] }
): { page: number; ref: (node?: Element | null) => void } => {
  const deps = config?.deps ?? [];
  const [isEnd, setIsEnd] = useState(false);
  const [page, setPage] = useState(config?.initialPage ?? 1);
  const [shouldFetch, setShouldFetch] = useState(true);
  const { isIntersecting: isInView, ref } = useIntersectionObserver({
    threshold: 0.5,
  });
  const dataRef = useRef(null);

  //reset on dependencies change
  useEffect(() => {
    setPage(1);
    setShouldFetch(true);
    setIsEnd(false);
  }, [JSON.stringify(deps)]);

  useEffect(() => {
    if (isEnd || !shouldFetch) {
      return;
    }

    cb();
    setShouldFetch(false);
  }, [JSON.stringify(deps), shouldFetch, isEnd]);

  useLayoutEffect(() => {
    if (isEnd || !shouldFetch) {
      return;
    }
    if (
      dataRef.current?.length === config?.data?.length &&
      config?.data !== undefined &&
      config?.data !== null
    ) {
      setIsEnd(() => true);
    }
    dataRef.current = config?.data;
  }, [config?.data?.length, isEnd, shouldFetch]);
  useEffect(() => {
    if (!isInView || isEnd) {
      return;
    }
    setPage((p) => p + 1);
    setShouldFetch(true);
  }, [isInView, isEnd]);
  return { page, ref };
};

export const paginate = <TData extends any[], TState extends any[]>({
  page,
  data,
  state,
}: {
  page: number;
  data: TData;
  state: TState;
}) => {
  return page && page > 1 ? [...state, ...data] : data;
};

export const apiPaginate = (
  pagination?: PaginateType,
  params?: URLSearchParams
) => {
  if (pagination && params) {
    params.append('limit', pagination.limit.toString());
    const offset = String((pagination.page - 1) * pagination.limit);
    params.append('offset', offset);
  }
};
export type PaginateType = {
  limit: number;
  page: number;
};
